import {priority} from '@priority-software/priority-proto-api/lib';
import {Operator} from '@priority-software/priority-utils/lib/operators';

import {ColumnType} from './column';
import * as range from '../moduls/filters/range';
import * as bool from '../moduls/filters/bool';
import * as text from '../moduls/filters/text';
import * as date from '../moduls/filters/date';
import * as time from '../moduls/filters/time';
import {DateRangeID} from '../../../common/dateRange';

export type DateEnum = DateRangeID | '';
export interface ISearchFilter {
    columnID?: number | Long | null;
    operator?: Operator;
    values?: string[] | null;
    ignoreCase?: boolean | null;
    dateEnum?: DateEnum[] | null;
}

export interface ISearchCondition extends ISearchFilter {
    id?: string;
    type: ColumnType;
    columnName: string;
    title: string;
    isSort?: boolean;
    isdesc?: boolean;
    origType: priority.netitems.form.ColumnType;
    conditionsOperator?: priority.netitems.shared.LogicalOperator;
}

export interface IQueryFilter {
    Condition?: IExtendedCondition[];
    isSort?: boolean;
    isdesc?: boolean;
}

interface moduleType {
    buildQuery: (filter: ISearchCondition) => priority.netitems.form.ICondition[];
    serialize: (filter: priority.netitems.form.ICondition[]) => ISearchFilter;
}
export interface IExtendedCondition extends priority.netitems.form.ICondition {
    ColumnName?: string;
}

export const typeTomodulsMapping: {[key: string]: moduleType} = {
    [ColumnType.Bool]: bool,
    [ColumnType.Text]: text,
    [ColumnType.Number]: range,
    [ColumnType.Date]: date,
    [ColumnType.Time]: time,
    [ColumnType.Duration]: range
};
